import React from 'react';
import { Input, Select, Icon,DatePicker,Col,Row } from 'antd';
import moment from 'moment';
import { lista_estado} from '../../../common/types/ordenCompraEstadoType';


const { Option } = Select; 

class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
            <Row gutter={16}>
          
                <Col className="gutter-row" sm={24} md={12} lg={7}>
      
                    <Select 
                          showSearch labelInValue
                          value={
                              this.props.filter.idProveedor ?
                                  { key: this.props.filter.idProveedor } : undefined
                          }
                            placeholder={"Seleccione Proveedor"}
                            optionFilterProp="children"
                            onChange={(option) => this.props.onChange('idProveedor', option.key)}
                        >
                            {this.props.entidades.map(item => (
                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                            ))}
                        </Select>

                </Col>

                        
                <Col className="gutter-row" sm={24} md={12} lg={4}>

                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idEstadoOrdenServicio ?
                                    { key: this.props.filter.idEstadoOrdenServicio } : undefined
                            }
                            placeholder={"Seleccione Estado"}
                            optionFilterProp="children"
                            onChange={(option) => this.props.onChange('idEstadoOrdenServicio', option.key)}
                        >
                            {lista_estado.map(item => (
                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                            ))}
                        </Select>

                </Col>


                <Col className="gutter-row" sm={24} md={12} lg={3}>
                    <Input
                        prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                        value={this.props.filter.serie}
                        onChange={(e) => this.props.onChange("serie", e.target.value)}
                        onKeyUp={this.props.onKeyUpSearch}
                        placeholder="Filtrar por serie"
                        autoComplete="off"
                    />
                </Col>
                <Col className="gutter-row" sm={24} md={12} lg={3}>
                    <Input
                        prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                        value={this.props.filter.documento}
                        onChange={(e) => this.props.onChange("documento", e.target.value)}
                        onKeyUp={this.props.onKeyUpSearch}
                        placeholder="Filtrar por documento"
                        autoComplete="off"
                    />
                </Col>
                <Col className="gutter-row" sm={24} md={12} lg={3}>
                    <DatePicker
                        placeholder="Filtrar por fecha inicio"
                        format="DD/MM/YYYY"
                        value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                        onChange={(moment, value) => this.props.onChange('fechaInicioStr', value)}
                    />
                </Col>
                <Col className="gutter-row" sm={24} md={12} lg={3}>
                    <DatePicker
                        placeholder="Filtrar por fecha fin"
                        format="DD/MM/YYYY"
                        value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                        onChange={(moment, value) => this.props.onChange('fechaFinStr', value)}
                    />
                </Col>
            </Row>
        </div>
        );
    }
}

export default Filters;